import { SKU_INVALID_CHAR_PATTERN, SKU_INVALID_CHAR_PATTERN_GLOBAL, SUFFIXED_SKU_PATTERN } from '@/constants'

/**
 * SKU character rules.
 *
 * SKUs may contain ONLY `A–Z`, `a–z`, and `0–9`. Everything else — spaces,
 * punctuation, symbols, emoji, accented/non-ASCII letters — is invalid and is
 * hard-rejected at entry (never allowed into the field) and blocks listing.
 *
 * Case is preserved as entered (lowercase is valid); empty is out of scope for
 * this rule — required/optional behaviour is governed elsewhere.
 *
 * Patterns + error strings live in `@/constants` (settings).
 */

// ⛔ TEMPORARILY DISABLED (CDP-2444) — SKU validation is commented out for now.
// Both helpers are neutered so every call site (input hard-reject in
// SkuCellEditor/SimpleInput/InventoryBlock, and the listing block in
// checkAreRequiredFieldsEmpty/ErrorModalBeforeListing) becomes a no-op:
//   • isValidSku always passes  → nothing blocks listing
//   • sanitizeSku is identity    → no characters stripped, no inline error flashed
// To re-enable, restore the original bodies below.
export const isValidSku = (/* value */) => true

export const sanitizeSku = (value) => String(value ?? '')

/**
 * Read-only base-36 card id that Batch Details shows after the SKU
 * (`47690 - 13oej6`) so the seller can see the full SKU that reaches the
 * marketplaces.
 *
 * The API now bakes that suffix into `sku` itself for new batches, so appending
 * it unconditionally rendered `47690-13oej6 - 13oej6`. Returns '' whenever the
 * value already carries a suffix, so it is never doubled.
 *
 * Detection is by shape (`SUFFIXED_SKU_PATTERN`), not by comparing to this
 * card's own id: the API has emitted SKUs carrying a neighbouring card's id
 * (`47696-13oekj` on the card whose id is `13oeki`), and re-appending our
 * locally computed id there reads as a second suffix just the same.
 */
export const skuIdSuffix = (sku, id) => {
  if (id == null) return ''

  const value = String(sku ?? '').trim()

  if (value && SUFFIXED_SKU_PATTERN.test(value)) return ''

  return id.toString(36)
}

/* Original implementation — restore to re-enable validation:
export const isValidSku = (value) =>
  value == null || value === '' || !SKU_INVALID_CHAR_PATTERN.test(String(value))

export const sanitizeSku = (value) => String(value ?? '').replace(SKU_INVALID_CHAR_PATTERN_GLOBAL, '')
*/
